import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_screenshot",
  "use": "micro_screenshot-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_screenshot\"><path fill-rule=\"evenodd\" d=\"M0 .995C0 .445.456 0 .995 0h8.01c.55 0 .995.456.995.995v8.01c0 .55-.456.995-.995.995H.995C.445 10 0 9.544 0 9.005V.995ZM1 1h1v1H1V1Zm2 0h1v1H3V1Zm2 0h1v1H5V1ZM1 3h8v6H1V3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol